/**
 * Tervuno scroll animations and interactions.
 * Uses IntersectionObserver with fallback for older browsers.
 */
(function () {
  'use strict';

  function initAnimations() {
    var elements = document.querySelectorAll('.tv-fade-up');
    if (!elements.length) return;

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      elements.forEach(function (el) {
        el.classList.add('tv-motion-ready');
        observer.observe(el);
      });
    } else {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var targetId = link.getAttribute('href');
        if (!targetId || targetId === '#') return;
        var target;
        try { target = document.getElementById(decodeURIComponent(targetId.slice(1))); } catch (error) { return; }
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
  }

  function initHeaderShadow() {
    var header = document.querySelector('.tv-header');
    if (!header) return;
    var lastScroll = 0;
    window.addEventListener(
      'scroll',
      function () {
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        if (currentScroll > 10 && currentScroll > lastScroll) {
          header.style.boxShadow = '0 4px 20px rgba(22, 51, 47, 0.08)';
        } else if (currentScroll <= 10) {
          header.style.boxShadow = 'none';
        }
        lastScroll = currentScroll;
      },
      { passive: true }
    );
  }

  function initCartBounce() {
    var cartLink = document.getElementById('tv-cart-link');
    var countEl = cartLink ? cartLink.querySelector('.tv-cart-count') : null;
    if (!cartLink || !countEl) return;

    function extractCount(text) {
      var match = (text || '').match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }

    var lastCount = extractCount(countEl.textContent);
    var observer = new MutationObserver(function () {
      var newCount = extractCount(countEl.textContent);
      if (newCount > lastCount) {
        cartLink.classList.remove('tv-cart-bounce');
        // force reflow
        void cartLink.offsetWidth;
        cartLink.classList.add('tv-cart-bounce');
        setTimeout(function () {
          cartLink.classList.remove('tv-cart-bounce');
        }, 600);
      }
      lastCount = newCount;
    });
    observer.observe(countEl, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAnimations();
      initSmoothScroll();
      initHeaderShadow();
      initCartBounce();
    });
  } else {
    initAnimations();
    initSmoothScroll();
    initHeaderShadow();
    initCartBounce();
  }
})();
